import { render, staticRenderFns } from "./VideoHeadlineItem.vue?vue&type=template&id=06d1c5dd&scoped=true"
import script from "./VideoHeadlineItem.vue?vue&type=script&lang=js"
export * from "./VideoHeadlineItem.vue?vue&type=script&lang=js"
import style0 from "./VideoHeadlineItem.vue?vue&type=style&index=0&id=06d1c5dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d1c5dd",
  null
  
)

export default component.exports